import { ALERT_MSG, ALERT_CLEAR } from 'constants/alert';

/**
 * Set msg warning
 * @param {string} title for title of alert
 * @param {string} message include alertType and message
 */
export const alert = ({ title, message, onClose }) => ({
  type: ALERT_MSG,
  alert: { title, message, onClose },
});

export const infoAlert = (message, onClose) => dispatch => {
  dispatch(
    alert({
      title: 'Thông báo',
      message,
      onClose,
    }),
  );
};

export const maintainAlert = () => dispatch =>
  dispatch(infoAlert('Hệ thống đang bảo trì'));
export const clearAlert = () => ({ type: ALERT_CLEAR });
